import { Connection, PublicKey, Transaction } from '@solana/web3.js';
import { decodeEventQueue, Market } from '@openbook-dex/openbook';
import { DEX_PID } from 'ts/accountInfo/openOrders';
import { MARKET_STATE_LAYOUT_V3, Orderbook } from '@openbook-dex/openbook/lib/market'
import { useEffect, useState } from 'react';
import { GetOrderBookWithEvents } from './orderbook';
import { useSelector } from 'react-redux';
export const SERUM_MARKETS_URL = "https://cache.prism.ag/openbook.json";

export const GetMarket = async (connection, marketAddress) => {
  
  //markets[base][quote]
  let market = await Market.load(connection, marketAddress, undefined, DEX_PID);
  console.log("[s] market data", marketAddress, marketAddress.toBase58(), market)
  return market;
}

export const UpdateOrderBook = async (connection, marketAddress) => {

}

export const filterForOpenOrders = (bids, asks, openOrdersAccounts) => {
  return [...bids, ...asks].filter((order) => openOrdersAccounts.some((openOrders) => order.openOrdersAddress.equals(openOrders.address)));
}

export const GetOpenOrdersAll = async (state) => {
  let marketIds = [];
  for (let i = 0; i < state.openOrders.length; i++)
    if (!marketIds.find(x => x.equals(state.openOrders[i].market)))
      marketIds.push(state.openOrders[i].market)
  let markets = await Promise.all(marketIds.map(id => Market.load(state.connection, id, undefined, DEX_PID)));
  let accounts = [];
  markets.map(m => accounts.push(m._decoded.bids, m._decoded.asks, m._decoded.eventQueue));
  let bidsAndAsks = await state.connection.getMultipleAccountsInfo(accounts, "confirmed");
  let allOrders = [];
  for (let i = 0; i < markets.length; i++) {
    let marketInfo = state.markets.find(m => m.market == markets[i].address.toBase58());
    if (!marketInfo) {
      console.log("Error market.js #40, No market found for " +  markets[i].address.toBase58());
    //   continue;
    }
    let base = "NAN", quote = "NAN";
    for(let j = 0; j < state.tokenList.tokens.length; j++) {
      if(state.tokenList.tokens[j].address === markets[i].baseMintAddress.toBase58()) base = state.tokenList.tokens[j].symbol;
      if(state.tokenList.tokens[j].address === markets[i].quoteMintAddress.toBase58()) quote = state.tokenList.tokens[j].symbol;
    }
    let bids = Orderbook.decode(markets[i], bidsAndAsks[3 * i].data);
    let asks = Orderbook.decode(markets[i], bidsAndAsks[3 * i + 1].data);
    let eventQueoe = decodeEventQueue(bidsAndAsks[3 * i + 2].data, 100)
      .filter((event) => event.eventFlags.fill && event.nativeQuantityPaid.gtn(0))
    let openOrdersAccounts = state.openOrders.filter(oo => oo.market.equals(markets[i].address));
    let orders = filterForOpenOrders(bids, asks, openOrdersAccounts)
    .map(x => {
      return {
        ...x,
        marketName: base + "-" + quote,
        market: markets[i].address.toBase58(),
        loadedMarket: markets[i],
      }
    })
    for (let fill of eventQueoe) {
      for(let i = 0; i < orders.length; i++) {
        if(orders[i].orderId.toString() === fill.orderId.toString()) {
          orders[i].fill = fill;
          break;
        }
      }
    }
    allOrders.push(...orders);
  }
  return allOrders;
}

export const GetOpenOrders = async (state, market) => {
  let orders = await market.serumMarket.loadOrdersForOwner(state.connection, new PublicKey(state.publicKey));
  let filled = [];
  for (let fill of await market.serumMarket.loadFills(state.connection)) {
    for(let i = 0; i < orders.length; i++) {
      if(orders[i].orderId.toString() === fill.orderId.toString()) {
        orders[i].fill = fill;
        break;
      }
    }
  }

  return orders;
}

export const PlaceOrder = async (market, state, info) => {
  // Placing orders
  // const owner = state.wallet.publicKey;
  // const transaction = new Transaction();
  // const signers = [];
  

  // market.makePlaceOrderTransaction(state.connection,
  //   {
  //     owner: state.publicKey, 
  //     payer: feePayer, 
  //     side: side, 
  //     price: price, 
  //     size: size, 
  //     orderType: orderType, 
  //     clientId: clientId, 
  //     openOrdersAddressKey: openOrdersAddressKey, 
  //     openOrdersAccount: openOrdersAccount, 
  //     feeDiscountPubkey: feeDiscountPubkey, 
  //     selfTradeBehavior: 'decrementTake'
  //   }, 120_000, 120_000
  // )
}



export const ParseSerumMarkets = async (state) => {

  let request = await fetch(SERUM_MARKETS_URL);
  let response = await request.json();

  let marketInfos = response.result.map(({ pubkey, account: { data, executable, owner, lamports } }) => ({
    publicKey: new PublicKey(pubkey),
    accountInfo: {
      data: Buffer.from(data[0], 'base64'),
      executable,
      owner: new PublicKey(owner),
      lamports
    }
  }));
  
  const serum = {
    all: {

    }
  };
  let markets = marketInfos.map((marketInfo) => {
    let market = {
      ...MARKET_STATE_LAYOUT_V3.decode(
        marketInfo.accountInfo.data
      ),
      provider: "serum"
    }
    return {
      address: marketInfo.publicKey.toBase58(),
      market: market,
    }
  })
  markets = markets.sort((a, b) => b.market.quoteDepositsTotal.toNumber() - a.market.quoteDepositsTotal.toNumber());
  markets.forEach((marketData) => {
    let {market, address} = marketData;

    let marketOverriden = false;
    for(let i = 0; i < state.marketOverrides.length; i++) {
      let base = market.baseMint.toBase58();
      let quote = market.quoteMint.toBase58();
      if(base === state.marketOverrides[i].base && quote === state.marketOverrides[i].quote) {
        if(market.ownAddress.toBase58() === state.marketOverrides[i].marketAddress) {
          serum.all[address] = market;
          let quoteMint = market.quoteMint.toBase58();
          let baseMint = market.baseMint.toBase58();
          
          (serum[baseMint] || (serum[baseMint] = {}))[quoteMint] = market;
          (serum[quoteMint] || (serum[quoteMint] = {}))[baseMint] = market;
          
          marketOverriden = true;
          break;
        }
      }
    }

    if(!marketOverriden) {
      let quoteMint = market.quoteMint.toBase58();
      let baseMint = market.baseMint.toBase58();
      if(!serum[baseMint] || !serum[baseMint][quoteMint]) {
        serum.all[address] = market;
        (serum[baseMint] || (serum[baseMint] = {}))[quoteMint] = market;
        (serum[quoteMint] || (serum[quoteMint] = {}))[baseMint] = market;
      }
    }
  })
  return serum;
}

export const UseMarket = (pair) => { // base, quote = SYMBOL || MINT_ADDRESS
  const [market, setMarket] = useState();
  const state = useSelector((state) => state.storage);
  const [pairs, setPairs] = useState(pair);
  const [marketObject, setMarketObject] = useState();
  const [orderbook, setOrderbook] = useState();
  const [returnObject, setReturnObject] = useState({});

  function updateMarket(_pair) {
    if(state.tokenList) {
      let base = undefined;
      let quote = undefined;
      for(let i = 0; i < state.tokenList.tokens.length; i++) {
        if(state.tokenList.tokens[i].address === _pair.base || state.tokenList.tokens[i].symbol === _pair.base) base = state.tokenList.tokens[i];
        if(state.tokenList.tokens[i].address === _pair.quote || state.tokenList.tokens[i].symbol === _pair.quote) quote = state.tokenList.tokens[i];
      }
      setPairs({base: base, quote: quote, market: _pair.market})
    }
  }

  useEffect(() => {
    try {
    // let interval = setInterval(UpdateOrderBook, 1000);
    if(state.serumMarkets && state.tokenList) {
      let baseMint = "";
      let quoteMint = "";

      if (pairs.base && pairs.quote) {
        for(let i = 0; i < state.tokenList.tokens.length; i++) {
          if(!state.tokenList.tokens[i].address) continue;

          if(state.tokenList.tokens[i].address === pairs.base.address)
            baseMint = state.tokenList.tokens[i].address;
          
          if(state.tokenList.tokens[i].address === pairs.quote.address)
            quoteMint = state.tokenList.tokens[i].address;
        }
      }
      console.log("[s] [D] [pairs]", baseMint, quoteMint, pairs)

      let market = (
        !pairs.market ?
        state.serumMarkets[baseMint][quoteMint].ownAddress :
        new PublicKey(pairs.market)
      );
      
      let readMarket = async () => { return state.serumMarkets[baseMint][quoteMint] };
      let getMarket = async () => {
        let accountData = await state.connection.getAccountInfo(market, "confirmed");
        return MARKET_STATE_LAYOUT_V3.decode(accountData.data);
      }

      let getMarketInfo = () => !pairs.market ? readMarket() : getMarket();

      getMarketInfo().then(marketInfo => {
        baseMint = marketInfo.baseMint.toBase58();
        quoteMint = marketInfo.quoteMint.toBase58();
        for(let i = 0; i < state.tokenList.tokens.length; i++) {
          if(state.tokenList.tokens[i].address === baseMint) pairs.base = state.tokenList.tokens[i];
          if(state.tokenList.tokens[i].address === quoteMint) pairs.quote = state.tokenList.tokens[i];
        }

        // if tokens not found, set as unknown
        if(!pairs.base) {
          pairs.base = {
            name:"Unrecognized Token",
            symbol: "UNKNOWN",
            address: baseMint
          }
        }
        if(!pairs.quote) {
          pairs.quote = {
            name:"Unrecognized Token",
            symbol: "UNKNOWN",
            address: quoteMint
          }
        }
        
        Market.load(state.connection, market, undefined, DEX_PID).then(_marketObject => {

        console.log("[s] [D] [mints]", baseMint, quoteMint, pairs, _marketObject);
        GetOrderBookWithEvents(state.connection, _marketObject).then(response => {
          setMarket(marketInfo);
          setMarketObject(_marketObject);
          setOrderbook(response);
          setReturnObject({
            market: marketInfo,
            marketAddress: market,
            serumMarket: _marketObject,
            orderbook: response,
            pairs: pairs
          })
        })
        
      })
    })
    }} catch (e) {
      console.log("[D]", e);
    }
    // return () => clearInterval(interval);
  },[state.serumMarkets, state.tokenList, pairs]);

  const UpdateOrderBook = async () => {
    if(marketObject && state.serumMarkets && state.tokenList)
      GetOrderBookWithEvents(state.connection, marketObject).then(response => {
        setOrderbook(response);
        setReturnObject({
          market: returnObject.market,
          marketAddress: returnObject.marketAddress,
          serumMarket: marketObject,
          orderbook: response,
          pairs: pairs
        })
      })
  }

  return [
    returnObject,
    updateMarket
  ];
}